import fp from 'lodash/fp';
import queryString from 'query-string';
import { push } from 'react-router-redux';
import { all, put, select, takeLatest } from 'redux-saga/effects';
import { questionType, routes } from '../../../../constants';
import { apiActionResult } from '../../common';
import { authTokenSelector } from '../../session';
import { actions, apiActions } from './actions';

export function* getContent(action) {
  const authToken = yield select(authTokenSelector);
  yield put(apiActions.business.content.get(authToken, action.payload.businessId, action.payload.skip, action.payload && action.payload.query));
}

export function* getNonCpdContent(action) {
  const authToken = yield select(authTokenSelector);
  yield put(apiActions.business.content.getNonCpdContent(authToken, action.payload.businessId));
}

export function* getContentById(action) {
  const authToken = yield select(authTokenSelector);
  yield put(apiActions.business.content.getById(authToken, action.payload.businessId, action.payload.contentId));
}

export function* saveContent(action) {
  const { content, nextRoute, businessId } = action.payload;
  const authToken = yield select(authTokenSelector);
  const apiAction = fp.has('payload.content.contentData.content')(action) && content.contentData.content.id ?
    'updateContent' :
    'addContent';
  const contentFormData = {
    data: content.contentData,
    file: content.files
  };

  yield put(fp.get(apiAction, apiActions.business.content)(authToken, businessId, contentFormData));

  const { success } = yield apiActionResult(fp.get(apiAction, actions.business.content.api));

  if (success && nextRoute) {
    const nextLocation = nextRoute.contentIdParam ?
      {
        ...nextRoute,
        search: `?${queryString.stringify({ contentId: success.payload.content.id })}`
      } :
      nextRoute;

    yield put(push(nextLocation));
  }
}

export function* archiveContent(action) {
  const { contentId, businessId } = action.payload;
  const authToken = yield select(authTokenSelector);

  yield put(apiActions.business.content.archiveContent(authToken, businessId, contentId));

  const { success } = yield apiActionResult(actions.business.content.api.archiveContent);

  if (success) {
    yield put(actions.business.content.get(businessId, 0, {}));
    yield put(actions.business.content.getNonCpdContent(businessId));
  }
}

export function* loadMoreContents(action) {
  const authToken = yield select(authTokenSelector);
  yield put(apiActions.business.content.loadMore(authToken, action.payload.businessId, action.payload.skip, action.payload.query));
}

export function* getContentQuestions(action) {
  const authToken = yield select(authTokenSelector);
  yield put(apiActions.business.content.getContentQuestions(authToken, action.payload.businessId, action.payload.contentId));
}

export function* saveQuestion(action) {
  const authToken = yield select(authTokenSelector);
  const { questionData, businessId } = action.payload;
  let answers = [];

  if (questionData.questionType === questionType.MultiChoice) {
    answers = fp.filter((a) => a.description && a.description.trim() !== '')(questionData.multiAnswers);
  }

  if (questionData.questionType === questionType.ShortAnswer) {
    answers = [Object.assign({}, questionData.shortAnswer, { isCorrect: true })];
  }

  if (questionData.questionType === questionType.NumericAnswer) {
    answers = [Object.assign({}, questionData.numericAnswer, { isCorrect: true })];
  }

  const contentQuiz = {
    question: {
      id: questionData.id,
      description: questionData.description,
      questionType: questionData.questionType,
      metaData: questionData.metaData
    },
    answers: answers
  };

  const contentQuizFormData = {
    data: contentQuiz,
    file: questionData.questionImage
  }

  if (contentQuiz.question.id) {
    yield put(apiActions.business.content.updateQuestion(authToken, businessId, questionData.contentId, contentQuiz.question.id, contentQuizFormData));
  }
  else {
    yield put(apiActions.business.content.addQuestion(authToken, businessId, questionData.contentId, contentQuizFormData));
  }
}

export function* deleteQuestion(action) {
  const authToken = yield select(authTokenSelector);
  const { contentId, questionId, businessId } = action.payload;
  yield put(apiActions.business.content.deleteQuestion(authToken, businessId, contentId, questionId));
}

export function* deleteContent(action) {
  const authToken = yield select(authTokenSelector);
  const { contentId, contentQuery, businessId } = action.payload;

  yield put(apiActions.business.content.deleteContent(authToken, businessId, contentId));

  const { success } = yield apiActionResult(actions.business.content.api.deleteContent);

  if (success) {
    yield put(actions.business.content.get(businessId, 0, contentQuery));
    yield put(actions.business.content.getNonCpdContent(businessId));
    yield put(push({ pathname: routes.app.library.content }));
  }
}

export function* getContentPassedUserEmails(action) {
  const authToken = yield select(authTokenSelector);
  yield put(apiActions.business.content.getContentPassedUserEmails(authToken, action.payload.businessId, action.payload.contentId));
}

export const sagas = all([
  takeLatest(actions.business.content.get().type, getContent),
  takeLatest(actions.business.content.getNonCpdContent().type, getNonCpdContent),
  takeLatest(actions.business.content.getById().type, getContentById),
  takeLatest(actions.business.content.saveContent().type, saveContent),
  takeLatest(actions.business.content.archiveContent().type, archiveContent),
  takeLatest(actions.business.content.loadMore().type, loadMoreContents),
  takeLatest(actions.business.content.saveQuestion().type, saveQuestion),
  takeLatest(actions.business.content.deleteQuestion().type, deleteQuestion),
  takeLatest(actions.business.content.getContentQuestions().type, getContentQuestions),
  takeLatest(actions.business.content.deleteContent().type, deleteContent),
  takeLatest(actions.business.content.getContentPassedUserEmails().type, getContentPassedUserEmails)
])

function* contentSagas() {
  yield sagas;
}

export default contentSagas;


// WEBPACK FOOTER //
// ./src/state/modules/business/content/sagas.js